import { PanInfo } from "framer-motion";

export const framerEasings = {
  custom: [0.34, 0.64, 0.01, 0.99],
};

export function onIntentToDismissDown(
  callback: (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => void
) {
  return (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => {
    const swipe = swipePower(info.offset.y, info.velocity.y);

    if (swipe >= swipeConfidenceThreshold) {
      callback(event, info);
    }
  };
}

export function onIntentToDismissUp(
  callback: (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => void
) {
  return (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => {
    const swipe = swipePower(info.offset.y, info.velocity.y) * -1;

    if (swipe >= swipeConfidenceThreshold) {
      callback(event, info);
    }
  };
}

export function onIntentToDismissLeft(
  callback: (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => void
) {
  return (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => {
    if (info.offset.x > 0) {
      return;
    }

    const swipe = swipePower(info.offset.x, info.velocity.x) * -1;

    if (swipe >= swipeConfidenceThreshold) {
      callback(event, info);
    }
  };
}

export const swipeConfidenceThreshold = 10000;
export const swipePower = (offset: number, velocity: number) => {
  return Math.abs(offset) * velocity;
};
